import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MyVacationPage from './pages/MyVacationPage';
import MyVacationDetailPage from './pages/MyVacationDetailPage';

const MyVacationModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MyVacationPage />} />
      <Route path="/:applicationId" element={<MyVacationDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MyVacationModule;
